
<template>
  <div class="border">
      <ul >
        <li><el-input-number v-model="listLiData.gt" controls-position="right"></el-input-number></li>
        <li><label style="padding-left: 0px;text-align: center"><= 入金范围 <</label></li>
        <li><el-input-number v-model="listLiData.lt" controls-position="right"></el-input-number></li>
        <li><label style="padding-left: 30px;text-align: center">赠金</label></li>
        <li><el-input-number v-model="listLiData.amount" controls-position="right"></el-input-number></li>
        <li>
          <div class="icon-area"
            @click="deleteList(listLiData.index,activeType)">
            <i class="el-icon-delete" style="font-size:24px;"></i>
          </div>
        </li>
      </ul>
  </div>
</template>

<script>
export default {
  props: ["listLiData",'activeType'],
  data() {
    return {
    };
  },
  methods: {
    deleteList(index,activeType) {
      let idIndex = {
        activeType:activeType,
        index: index
      };
        this.$emit("deleteListData", idIndex);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.test .el-form-item__content {
  display: flex;
}
.test .el-form-item__content .el-select--default {
  margin: 0 20px;
}
.task .el-checkbox-group {
  display: flex;
  flex-direction: column;
  height: 200px;
  overflow: scroll;
}
.border {
  margin-bottom: 15px;
 ul{
   display: flex;
   align-items: center;
   li{
     width: 180px;
     margin-right: 12px;
     .el-select{
       width: 180px;
     }
   }
 }
}
.icon-area{
  text-align: center;
}

.task .el-checkbox + .el-checkbox {
  margin-left: 0;
}
</style>
